module.exports = __webpack_public_path__ + "static/media/015.6dc29950.jpg";